export const useUserClassroomDataStore = (classroomId: string) => {
  const uid = useCurrentUID();

  if (!uid) {
    throw new Error("User is not logged in");
  }

  return useClassroomDataStore(uid, classroomId);
};
